/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [headline-user-entry.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 28.02.20, 21:32
 */
import React, {useRef, useState} from 'react';

import {HeadlineTitle2} from "../navigation/links/nav-headlines";

const EventToggler = ({children, title, visible = false, icon, ...otherProps}) => {
    const refElem = useRef(null);
    const [isVisible, setIsVisible] = useState(visible);

    const toggle = (event) => {
        event.preventDefault();
        const isVisible = refElem.current.classList.toggle('active-show');
        setIsVisible(isVisible);
    };

    return <div className="headline-entry">
        <HeadlineTitle2 title={title} onClick={toggle} icon={icon} open={visible} {...otherProps} />
        <div className={`headline-text-toggle ${isVisible ? 'active-show' : ''}`} ref={refElem}>
            {children}
        </div>
    </div>;
}

export default EventToggler;